const IconCoupDeCoeur = props => (
	<svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 10 10" {...props}>
		<path
			fill="currentColor"
			strokeWidth={0}
			d="M5,9.6l-.7-.7C1.7,6.6,0,5.1,0,3.2S1.2.4,2.8.4s1.7.4,2.2,1c.5-.6,1.4-1,2.2-1,1.5,0,2.8,1.2,2.8,2.8s-1.7,3.4-4.3,5.8l-.7.7h0Z"
		/>
	</svg>
);

export default IconCoupDeCoeur;
